angular.module('impactx.dialog').service('FreeFormDialogService', [
    'AppConfiguration',
    '$rootScope',
    FreeFormDialogService
]);

function FreeFormDialogService(AppConfiguration, $rootScope) {
    var self = this;
    self.typeComplete = 1;
    self.typeItems = 2;
    self.freeformOfferLotSelect = AppConfiguration.get('freeformOfferLotSelect');

    self.addWatchSelection = function (scope, forwardFunc) {
        let watched = "";
        if(self.freeformOfferLotSelect) {
            watched = "data.lot.selected";
        }
        else {
            watched = "data.contract.selected";
        }
        scope.$watch(function () {
            // returns "watched"
            return (impactX.isDefined(scope, "data.supplier.selected") || scope.supplierId > 0) && impactX.isDefined(scope, watched);
        }, function (newVal) {
            if(scope.ignoreWatchOnce) {
                scope.ignoreWatchOnce = false;
                return;
            }
            if(scope.wizardIndex == 0 && impactX.isDefined(newVal, "secondValue")) {
                switch(Number(newVal.secondValue)) {
                    case 1: // Only Detailed
                        forwardFunc(self.typeItems);
                        break;
                    case 2: // Only Fast
                        forwardFunc(self.typeComplete);
                        break;
                    default:
                        $rootScope.$broadcast('$mdDialogUpdate');
                }
            }
        })
    }

    self.showOption = function (scope, type) {
        var option;
        if(self.freeformOfferLotSelect) {
            option = scope.data.lot;
        }
        else {
            option = scope.data.contract;
        }
        if(scope.wizardIndex == 0 && impactX.isDefined(option, "selected.secondValue")) {
            switch(Number(option.selected.secondValue)) {
                case 0:
                    return true;
                case 1:
                    return type === self.typeItems;
                case 2:
                    return type === self.typeComplete;
            }
        }
        return false;
    }

}